



























import { Prop, Component, Vue } from "vue-property-decorator";
import { GetSalesReportQuery } from "@/sales/api/sales-report-api";

export interface GetSalesReportQueryDetails
  extends Partial<GetSalesReportQuery> {
  companyName: string;
  companyTypeName: string;
  staffName: string;
  vendorName: string;
  periodName: string;
}

/**
 * 請求レポートの検索条件の表示
 */
@Component({})
export default class SalesReportQuery extends Vue {
  @Prop({ type: Object, required: true }) query!: GetSalesReportQueryDetails;

  get someQuery(): boolean {
    return Boolean(
      this.query.companyId ||
        this.query.companyType ||
        this.query.staffId ||
        this.query.vendorId ||
        this.query.monthOptions
    );
  }
}
